import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { UploadTreatmentAddWellComponent } from '../upload-treatment-add-well.component';
import { NbDialogService } from '@nebular/theme';
import { Router } from '@angular/router';
import { HttpEventType } from '@angular/common/http';
import { TreatmentService } from '../../../../shared/services/treatment.service';
import { ToasterService, LoadingOverlayService } from '../../../../shared/services';
import { ENUM_THEMES } from '../../../../shared/helpers/app.constants';
import { ThemesSettingsService } from '../../../../shared/services/themes-settings.service';

const MIME_TYPES_ALLOW = ['application/xml', 'text/xml'];

@Component({
  selector: 'app-upload-treatment-files',
  templateUrl: './upload-treatment-files.component.html',
  styleUrls: ['./upload-treatment-files.component.scss']
})
export class UploadTreatmentFilesComponent implements OnInit {
  uploader: FileUploader = new FileUploader({});
  selectedFile = null;

  uploadStatusCode = {
    failed: -1,
    uploading: 1,
    succeed: 2
  };

  pageState = {
    isLoading: false,
    uploadProgress: 0,
    dropZoneOver: false,
    uploading: false,
    uploadStatus: null
  };

  isDarkTheme: boolean;

  constructor(
    private router: Router,
    private nbDialogService: NbDialogService,
    private treatmentService: TreatmentService,
    private toasterService: ToasterService,
    private loadingOverlayService: LoadingOverlayService,
    private themesSettingsService: ThemesSettingsService
  ) {
    this.onCheckDarkThemes();
  }

  private onCheckDarkThemes(): void {
    const localData = this.themesSettingsService.getLocalStorage();
    if (localData && localData.themes === ENUM_THEMES.Dark) {
      this.isDarkTheme = true;
      if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
    } else {
      this.isDarkTheme = false;
      document.body.classList.remove('frac-dark-theme');
    }
  }

  ngOnInit() {
  }

  addWell() {
    this.nbDialogService.open(UploadTreatmentAddWellComponent, {
      autoFocus: false,
      context: {}
    })
      .onClose.subscribe(data => {
        if (data) {
          this.handleAddManualWell(data);
        }
      });
  }

  handleAddManualWell(data) {
    if (data) {
      const { noTreatmentsUpload } = data;
      this.pageState.isLoading = true;
      this.treatmentService.createWellManual(data, () => {
        this.pageState.isLoading = false;
      }).subscribe(response => {
        if (response && response.result && response.result.wellId) {
          const { wellId, wellName, jobStartDate } = response.result;
          this.navigateToDataView({ wellId, wellName, jobStartDate, noTreatmentsUpload });
        }
      });
    }
  }

  navigateToDataView(params = {}) {
    this.router.navigate(['pages/treatments/uploadTreatment/table'], { queryParams: params });
  }

  chooseFile(event, inputFileEl) {
    event.preventDefault();
    if (inputFileEl) {
      inputFileEl.click();
    }
  }

  fileSelectChange(files) {
    this.selectedFile = files[0];
    this.uploader.queue = [this.uploader.queue[this.uploader.queue.length - 1]];
    this.pageState.uploadProgress = 0;
    this.pageState.uploadStatus = null;
  }

  fileOverHandler(e: any) {
    this.pageState.dropZoneOver = e;
  }

  submitUpload() {
    if (this.selectedFile) {
      if (MIME_TYPES_ALLOW.indexOf(this.selectedFile.type) > -1) {
        this.pageState.uploadProgress = 0;
        this.pageState.uploadStatus = this.uploadStatusCode.uploading;
        this.loadingOverlayService.show();
        this.treatmentService.uploadXMLCreateWell(this.selectedFile).subscribe(
          (evt) => {
            if (evt.type === HttpEventType.UploadProgress) {
              if (evt.total > 0) {
                this.pageState.uploadProgress = Math.round(evt.loaded / evt.total * 100);
              }
            } else if (evt.type === HttpEventType.Response) {
              if (evt.status === 200 && evt.body && evt.body.result) {
                if (evt.body.result.wellId) {
                  const wellId = evt.body.result.wellId;
                  const wellName =  evt.body.result.wellName;
                  const queryParams = { wellId, wellName };
                  setTimeout(() => {
                    this.loadingOverlayService.hide();
                    this.pageState.uploadStatus = this.uploadStatusCode.succeed;
                    this.navigateToDataView(queryParams);
                  }, 500);
                }
              }
            }
          },
          (err) => {
            this.pageState.uploadProgress = 0;
            this.pageState.uploadStatus = this.uploadStatusCode.failed;
            this.loadingOverlayService.hide();
          }
        );
      } else {
        this.toasterService.showError('Please select a WITSML file.');
      }
    }
  }

}
